import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// src/index.js
import './chartjs-fix';
import { Chart, BarController, BarElement, LinearScale, CategoryScale } from 'chart.js';
Chart.register(BarController, BarElement, LinearScale, CategoryScale);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
